import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '@/api/dashboard.api';

export const dashboardKeys = { overview: ['dashboard', 'overview'] as const };

export const useDashboardOverview = () => useQuery({
  queryKey: dashboardKeys.overview,
  queryFn: dashboardApi.overview,
});
